// ai.js
import dayjs from 'dayjs'
import app from './app.js'
import { setCookie, getCookie, isLogin } from './common'
import fetch from 'api/fetch'
/**
 * [birthday_children, birthday_middle, birthday_old, birthday_unknown, birthday_young]
 * [age < 22 ? 1: 0, 40 < age < 50 ? 1 : 0, age > 50 ? 1 : 0, 未知生日 ? 1 : 0, 22 < age < 40 ? 1 : 0]
 * if 语句顺序不可调整 互相有联系
 * @param {Date} date 生日
 * @return {Array} 生日参数
 */
function birthday(date) {
  const currentYear = dayjs().year()
  let age = ''
  // 存在生日
  if (date) age = currentYear - Number(date.slice(0, 4))

  // 生日未知
  if (!age) return [1, 0, 0, 0, 0]

  // [0, 22)
  if (age < 22) return [0, 1, 0, 0, 0]

  // [22, 40)
  else if (age < 40) return [0, 0, 1, 0, 0]

  // [40, 50)
  else if (age < 50) return [0, 0, 0, 1, 0]

  // >= 50
  else return [0, 0, 0, 0, 1]
}

/**
 * [未知收货地址, 收货地址一线城市, 收货地址二线城市, 收货地址三线城市]
 * if 语句的顺序不可调整 互相有联系
 * @param {String} city 城市
 * @return {Array} 城市参数
 */
function receiver(city) {
  const one = [
    '北京市',
    '上海市',
    '广州市',
    '深圳市',
    '成都市',
    '重庆市',
    '杭州市',
    '西安市',
    '武汉市',
    '苏州市',
    '郑州市',
    '南京市',
    '天津市',
    '长沙市',
    '东莞市',
    '宁波市',
    '佛山市',
    '合肥市',
    '青岛市',
    '苏州市',
    '长沙市',
    '惠州市'
  ]
  const two = [
    '天津市',
    '石家庄市',
    '太原市',
    '呼和浩特市',
    '沈阳市',
    '大连市',
    '长春市',
    '哈尔滨市',
    '宁波市',
    '福州市',
    '厦门市',
    '南昌市',
    '济南市',
    '青岛市',
    '郑州市',
    '武汉市',
    '长沙市',
    '南宁市',
    '海口市',
    '重庆市',
    '成都市',
    '贵阳市',
    '昆明市',
    '西安市',
    '兰州市',
    '西宁市',
    '银川市',
    '乌鲁木齐市'
  ]
  // 未知
  if (!city) return [1, 0, 0, 0]

  // 一线城市
  if (one.includes(city)) return [0, 1, 0, 0]

  // 二线城市
  if (two.includes(city)) return [0, 0, 1, 0]

  // 三线城市
  else return [0, 0, 0, 1]
}

/**
 * [model_iqoo_neo, model_iqoo_x, model_iqoo_z, model_other, model_vivo_s, model_vivo_x, model_vivo_y]
 * if 语句的顺序不可调整 互相有联系
 * @param {String} info model
 * @return {Array} 手机类型参数
 */
function model(info) {
  // iqoo neo
  if (/neo/i.test(info)) return [0, 1, 0, 0, 0, 0, 0]
  // iqoo z
  if (/z/i.test(info)) return [0, 0, 1, 0, 0, 0, 0]
  // iqoo x 旗舰
  if (/iqoo/i.test(info)) return [0, 0, 0, 1, 0, 0, 0]
  // vivo y
  if (/y/i.test(info)) return [0, 0, 0, 0, 1, 0, 0]
  // vivo x
  if (/x/i.test(info)) return [0, 0, 0, 0, 0, 0, 1]
  // vivo s
  if (/s/i.test(info)) return [0, 0, 0, 0, 0, 1, 0]
  // 未知机型
  return [1, 0, 0, 0, 0, 0, 0]
}

/**
 * [女性, 男性, 未知性别]
 * if 语句的顺序不可调整 互相有联系
 * @param {String} info sex
 * @return {Array} 性别参数
 */
function sex(info) {
  // 男
  if (info == 1) return [0, 0, 1]

  // 女
  if (info == 2) return [0, 1, 0]

  // 未知
  else return [1, 0, 0]
}

// AI参数
function AIParameter(info) {
  const obj = info || {}

  const arr1 = birthday(obj.date)
  const arr2 = receiver(obj.city)
  const arr3 = model(obj.model)
  const arr4 = sex(obj.sex)

  const arr = arr1.concat(arr2, arr3, arr4)

  return arr
}

// 清洗数据
function cleanData(params) {
  const skuIdsArr = params.skuIdsArr || [] // 获取skuIds数组
  const meddleIds = params.meddleIds || [] // 获取人工推荐的skuIds数组

  const filterArr = meddleIds?.concat([params.skuId])
  return skuIdsArr.filter(item => !filterArr.includes(Number(item))) // 过滤掉人工推荐的skuIds和当前skuId
}

// 查询收货地址
function queryAddress() {
  return fetch({
    url: '/v1/my/address/list',
    unLogin: true
  })
}

function getAIData(params) {
  return new Promise((resolve, reject) => {
    // AI推荐处理逻辑
    const data = params || {}
    const skuId = data.skuId
    // 筛选出人工推荐
    const meddle = data.meddle?.filter(item => item.recallSource == 6)
    const meddleIds = meddle?.map(item => item.id) // 提取出人工推荐skuids

    // 获取模型版本号及其它信息
    app.getInfoForModel(async (info)=> {
      // 获取默认城市
      let defaultCity = getCookie('defaultAICity')
      const isLog = await isLogin()
      if (!defaultCity && isLog) {
        let address = await queryAddress()
        defaultCity = address[0]?.city
        setCookie('defaultAICity', defaultCity, 3)
      }
      const modelVersion = info.modelVersion // 模型版本
      const model = info.isVivoPhone ? info.model : '' // 非vivo手机置为未知机型
      const obj = {
        date: info.birthday,
        city: defaultCity,
        model: model,
        sex: info.sex
      }
      const parameters = AIParameter(obj).toString() // 模型参数
      let query = { inputData: parameters }
      const goodsType = data.goodsType
      if (goodsType == 1) { // 当前商品类型为手机
        // 30手机+10配件
        query.phoneNum = 30
        query.partNum = 10
      } else { // 当前商品类型为配件
        // 30配件+10手机
        query.phoneNum = 10
        query.partNum = 30
      }
      if (modelVersion == 22) {
        // v2.2模型添加浏览当前商品行为
        query.inputData +=  ',' + skuId
      }
      app.modelInutdata(query, function(modelData) {
        if (modelData?.code == 0) { // 模型调用成功逻辑
          const phoneSkuIdsArr = modelData.phoneSkuIds.split(',') // 手机skuIds 数据
          const partSkuIdsArr = modelData.partSkuIds.split(',') // 配件skuIds 数据
          const oneSkuIds = cleanData({
            skuIdsArr: goodsType == 1 ? phoneSkuIdsArr : partSkuIdsArr,
            skuId: skuId,
            meddleIds: meddleIds
          })
          const twoSkuIds = cleanData({
            skuIdsArr: goodsType == 1 ? partSkuIdsArr : phoneSkuIdsArr,
            skuId: skuId,
            meddleIds: meddleIds
          })
          resolve({ oneSkuIds, twoSkuIds, modelVersion })
        } else {
          reject(() => { });
        }
      })
    })
  })
}
export { getAIData }
